import Axios from '@/libs/services'

const Request = new Axios()

const version = 'v1'

class AuthService {
  submitLogin = body => {
    const service = ''
    const uri = 'token/'
    const { email, password } = body

    return Request.post({ body: { email, password }, service, uri, version, skipAuth: true })
  }

  register = body => {
    const service = 'accounts'
    const uri = 'registration/'

    return Request.post({ version, body, service, uri, skipAuth: true })
  }

  getAdminInvite = token => {
    const service = 'admin-invite/'

    return Request.get({ version, service, query: { token }, skipAuth: true })
  }

  acceptAdminInvite = (body, token) => {
    const service = 'admin-invite'
    const uri = 'accept/'

    return Request.post({ version, service, uri, body, query: { token }, skipAuth: true })
  }

  activateAccount = token => {
    const service = 'accounts'
    const uri = 'activation/'

    return Request.post({ version, query: { token }, service, uri, skipAuth: true })
  }

  resetPassword = body => {
    const service = 'accounts/password'
    const uri = 'reset/'

    return Request.post({ version, service, uri, body, skipAuth: true })
  }

  confirmResetPassword = body => {
    const service = 'accounts/password'
    const uri = 'confirm/'

    return Request.post({ version, body, service, uri, skipSnakeCase: true, skipAuth: true })
  }
}

export default new AuthService()
